(ns app.front.view.public-notice.neighbours
  (:require [app.domain.property.model :as property-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::neighbours-visible?
  (fn [[_ target-id] _]
    [(rf/subscribe [::ws-subs/neighbours])
     (rf/subscribe [::process/signal-permitted? target-id [:process.signal/edit-neighbour-properties]])])
  (fn [[neighbours add-permitted?] _]
    (or (seq neighbours)
        add-permitted?)))

(defn render-neighbour [tr {:keys [id property owners]}]
  (let [owners-count (count owners)]
    [:div.w-full.lg:w-1-2.xl:w-1-3.px-3
     [:div.flex.p-3.my-2.bg-white.rounded-md
      [:div.w-2-3.mt-1
       [:span.block.clear.mb-2 id]
       [:span.block.clear (property-model/full-address property)]]
      [:div.w-1-3
       [:div.float-right.-mr-2
        [ui/pill {:color (when (= 0 owners-count) :red)
                  :text  owners-count}]
        [:div.ml-1.mt-1 (tr [:neighbours/owners])]]]]]))

(defn section [{:keys [tr fsm-target]}]
  (when (<sub [::neighbours-visible? (:db/id fsm-target)])
    (let [neighbours (<sub [::ws-subs/neighbours])]
      [:div.items-center.mb-4.bg-ui-light-gray.p-4
       [:div.flex.justify-between.flex-nowrap.items-center.mb-4
        [:h4.uppercase (tr [:public-notice/neighbours])]
        (when (<sub [::process/signal-permitted? fsm-target [:process.signal/edit-neighbour-properties]])
          [cc/button
           {:kind :tertiary
            :href (href/href :view/neighbour-properties {:workspace-id (<sub [::ws-subs/workspace-id])})}
           (tr [:neighbours/manage-properties])])]
       [:div.flex.flex-wrap.-mx-3
        (for-frag [{:keys [:property/id :property/owners] :as property} neighbours]
          ^{:key id}
          [render-neighbour tr (util/mmap id property owners)])]])))
